import { render, staticRenderFns } from "./DesionCommonClosestS.vue?vue&type=template&id=514e235a&scoped=true&"
import script from "./DesionCommonClosestS.vue?vue&type=script&lang=js&"
export * from "./DesionCommonClosestS.vue?vue&type=script&lang=js&"
import style0 from "./DesionCommonClosestS.vue?vue&type=style&index=0&id=514e235a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e235a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
